<template>
  <section class="chat-body">
    <div v-for="message in messages" :key="message.id">
      <span :class="[ message.senderId === currentUser.id ? 'user' : 'support']" class="message">{{ message.text }}</span>
    </div>
  </section>
</template>

<script>
import { sendMessage, launchChat, createRoom, addSupportStaffToRoom, connectToRoom } from '../chat/chat.js';

export default {
  name: 'ChatBody',
  props: {
    newMessage: String,
    messages: Array,
    currentUser: {
      type: Object,
      required: true,
      default: null,
    },
  },
  methods: {
    handleInput(event) {
      const { name, value } = event.target;
      this.$emit('update-input', name, value);
    },
    handleSubmit() {
      this.$emit('send-message');
    },
    sendMessage,
    launchChat,
    createRoom,
    addSupportStaffToRoom,
    connectToRoom,
  }
}
</script>